import { h } from 'preact'

import s from './Nettverksfeil.module.css'
import { Message } from '../../../../../lib/intl/Message'
import { Profil } from '../../../shared/Decoration'
import { Icon } from '../../../shared/Icons/Icons'
import { reloadResultat } from '../../../../store/actions'
import { useStore } from '../../../../../lib/redux-provider-nohooks'

export function Nettverksfeil() {
  const store = useStore()
  function handleClick() {
    store.dispatch(reloadResultat())
  }

  return (
    <section class={s.nettverksfeil}>
      <h3>
        <Message id="nettverksfeil-tittel" />
      </h3>
      <p>
        <Message id="nettverksfeil-tekst" />
      </p>
      <button class="nrk-button" onClick={handleClick}>
        <Message id="nettverksfeil-lenketekst" />
        <Icon type="nrk-reload" />
      </button>
      <Profil inElement={true} id="nettverksfeil-banner" class={s.bunnDekor} />
    </section>
  )
}
